import { AdPlacement } from "@/components/ads/AdPlacement";
import {
  SciBreadcrumb,
  SciExplainer,
  SciHeader,
  SciPage,
} from "@/lib/science/sci-ui";
import { m } from "@/paraglide/messages";
import { IdealWeightCalc } from "../components/IdealWeightCalc";

export function CalculatorPage() {
  return (
    <SciPage>
      <SciBreadcrumb
        homeLabel={m.sci_breadcrumb_home()}
        toolName={m.iw_tool_name()}
        toolPath="/ideal-weight-calculator"
      />
      <SciHeader title={m.iw_h1()} intro={m.iw_intro()} />
      <IdealWeightCalc />
      <SciExplainer
        howToTitle={m.sci_howto_title()}
        howTo={m.iw_howto()}
        examplesTitle={m.sci_examples_title()}
        examples={[m.iw_ex1(), m.iw_ex2(), m.iw_ex3()]}
        faqTitle={m.sci_faq_title()}
        faqs={[
          { q: m.iw_faq_q1(), a: m.iw_faq_a1() },
          { q: m.iw_faq_q2(), a: m.iw_faq_a2() },
          { q: m.iw_faq_q3(), a: m.iw_faq_a3() },
          { q: m.iw_faq_q4(), a: m.iw_faq_a4() },
        ]}
      />
      <AdPlacement className="mt-10" />
    </SciPage>
  );
}
